import { render, staticRenderFns } from "./testPaperEdit.vue?vue&type=template&id=62a3f689"
import script from "./testPaperEdit.vue?vue&type=script&lang=js"
export * from "./testPaperEdit.vue?vue&type=script&lang=js"
import style0 from "./testPaperEdit.vue?vue&type=style&index=0&id=62a3f689&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports